<template lang="pug">

#tc(v-show="active")

  .content
    .swoosh
      swoosh-icon
    h1
      p NIKE“突破速度挑战赛”
      p 线上活动须知

    h2
      img.bg(src="~assets/result/btn-blue.png")
      .label
        span 活动规则
    p 本次活动时间，自2017年6月8日0时开始至7月5日24时结束。在活动开始前或者活动结束后参与活动均属无效。 
    p 用户只需以尽快速度滑动屏幕，完成线上比赛，即可获得“突破速度挑战赛”定制T恤抽奖机会。

    h2
      img.bg(src="~assets/result/btn-blue.png")
      .label
        span 奖品说明
    p 活动奖品：“突破速度挑战赛”定制T恤一件（共20件）
    p 用户完成比赛后，即可点击进入抽奖参与页面，留下个人联系方式。
    p 我们将于7月6日抽取20名获奖者，每位获奖者将获赠“突破速度挑战赛”定制T恤一件。届时，我们将致电联系中奖者一一告知中奖信息及领奖方式。

    h3 关于以上所有奖品：
    ul
      li 中奖者留下的个人信息需真实准确，并保持手机畅通。若因客观原因无法顺利联系到获奖者，此获奖资格将作废。
      li 获奖资格不得转让，亦不能兑换现金或者其他等价物。本次活动的奖品不设调换。但主办方保留在法律允许的范围内，如因奖品无法提供或者主办方自主判决的其他原因不能提供的情况下，替换其他相同或者更高金额的奖品的权利。获奖者应负责上述未明确列明由主办方承担的其他税费。
      li 如果获奖者拒绝接受奖品，不符合参与条件或者有违反本次活动《活动须知》的情况，主办方有权立即取消获奖者的中奖资格，并另行选择获奖者。
      li 在法律允许的范围内，主办方有权对获奖者是否符合参与及中奖资格进行独立判断，并做出最终决定。

    h2
      img.bg(src="~assets/result/btn-blue.png")
      .label
        span 其他
    ul
      li 本次活动由耐克体育（中国）有限公司主办。
      li 未经主办方许可，参加者不得利用本次参加事宜或参加活动本身进行任何形式的商业性或非商业性的市场开发或宣传活动等。
      li 参加者同意主办方可以为组织本次活动的目的收集并且授权第三方使用其个人信息。
      li 主办方不对因网络传输原因而导致参加者提交的信息丢失或错误承担任何责任。如遇不可抗力，包括但不限于自然灾害、天气原因、罢工、网络故障、政府临时管制、恐怖活动等因素导致本次活动因故无法进行时，主办方有权在法律允许的范围内决定取消、终止、修改或暂停本次活动。届时，主办方将另行通知相关事宜。
      li 在法律允许的范围内，耐克体育（中国）有限公司拥有对本次活动的最终解释权。
      li
        span 参加者的个人信息保护：通过本次活动收集的个人信息均适用耐克的个人信息保护政策，你可以阅读
        a(href="http://help-zh-cn.nike.com/app/answers/detail/article/privacy-policy/a_id/16423/p/3897") 《耐克网络隐私政策》
        span 获取更多信息。

  .close-button(v-on:click="close")
    CloseIcon


</template>

<script>
import SwooshIcon from 'src/assets/swoosh.svg'
import CloseIcon from 'src/assets/close-icon.svg'

export default {
  name: 'tc',
  props: [
    'active'
  ],
  components: {
    SwooshIcon,
    CloseIcon
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"


#tc
  +full()
  z-index: 100
  background: $cl-red
  font-style: normal
  font-family: "TradeGothicLTStd", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"

.swoosh
  left: 0
  right: 0
  text-align: center
  padding-top: 14px

  svg
    height: 5vmin
    fill: white
    margin: $ui-padding * 0.75 auto

.close-button
  position: absolute
  top: 0
  right: 0
  width: 50px
  height: 50px
  +flex-center()
  cursor: pointer

  svg
    stroke: white
    stroke-width: 2px

.content
  +full()
  overflow-x: visible
  overflow-y: auto
  text-align: left
  padding: 0 24px 24px
  pointer-events: all

h1
  text-align: center
  font-size: 1.5rem
  margin: 0
  font-style: italic

h2
  position: relative
  margin: 20px 0 10px
  margin-left: -24px - 6px

  .bg
    position: absolute
    height: 100%

  .label
    position: relative
    font-size: 1rem
    padding: 6px (24px + 6px)

h3
  margin-top: 14px

ul
  padding-left: 24px

li
  list-style-type: disc
  margin: 6px auto

a

</style>



// WEBPACK FOOTER //
// Tc.vue?3db558e4